<script>

  import Footer from "../components/Footer/Footer.svelte";
  import MessageBoard from "../components/MessageBoard/MessageBoard.svelte";
  import ProgressBar from "../components/ProgressBar.svelte";
  import WideButton from "../components/WideButton.svelte";
  import WeekDropdown from "../components/WeekDropdown.svelte";

  import { uploadSubmission, getFlamelinkZoomLink, getFlamelinkWeeks } from "../services/flamelink";
  import { isFileMp4, isFileImage } from "../services/imageUtil";
  import { onMount } from 'svelte'
  import { navigate} from "svelte-routing";

  export let user;



  $: lunchRoomLink = "";
  $: imageOrVideoFile = null;
  $: uploadSource = null;
  $: uploadCompleted = false;
  $: progressCompleted = 0;
  $: fileIsUploading = false;


  const onClickLunchRoom = () => {
    window.open(lunchRoomLink,'_newtab')
  }



  const onClickUploadImage = () => {
    uploadCompleted = false;
    document.getElementById("fileid").click();
  };


  const onFileInputChange = async (event) => {
    const file = event.srcElement.files[0];

    let isImage = isFileImage(file);
    let isVideo = isFileMp4(file);

    if (!isImage && !isVideo) {
      alert("Only accept .mp4, .png, .jpg, .gif");
      return;
    }

    imageOrVideoFile = file;
    uploadCompleted = false;
    uploadSource = await readURL(file);
  };

  const readURL = async (file) => {
    if (isFileMp4) {
      return URL.createObjectURL(file);
    }

    return new Promise(async (res, rej) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        res(e.target.result);
      }; // this is what is returned in the promise.. weird ik
      reader.onerror = (e) => console.log("ERROR : ", e);
      reader.readAsDataURL(file);
    });
  };

  const onUploadFile = async () => {
    fileIsUploading = true;
    const onProgressUpdated = (progPercent) => {
      progressCompleted = progPercent;
    };

    await uploadSubmission(
      imageOrVideoFile,
      user.username,
      currentWeek.weekName,
      onProgressUpdated
    );

    imageOrVideoFile = undefined;
    uploadSource = undefined;
    uploadCompleted = true;
    fileIsUploading = false;
    document.body.scrollTop = 150; // For Safari
    document.documentElement.scrollTop = 150; // For Chrome, Firefox, IE and Opera
  };

  const cancelUpload = () => {
    fileIsUploading = false;
    imageOrVideoFile = undefined;
    uploadSource = undefined;
    uploadCompleted = false;
    fileIsUploading = false;
  }


  $: briefingRoomDescription = ''

  getFlamelinkZoomLink().then(link => {

    let briefingRoomLink = Object.keys(link).map(key => link[key])[0].link;
    let description = Object.keys(link).map(key => link[key])[0].description;

    lunchRoomLink = link != null ? briefingRoomLink : ''
    briefingRoomDescription = description
  })

  $: weeks = [];
  $: currentWeek = ''

  getFlamelinkWeeks().then(allWeeks => {
    console.log("WEEKS", allWeeks);

      function compare( a, b ) {
        if ( a.orderToAppear < b.orderToAppear ){
          return -1;
        }
        if ( a.orderToAppear > b.orderToAppear ){
          return 1;
        }
        return 0;
      }

    let data = Object.keys(allWeeks).map(key => {return allWeeks[key]}).sort(compare)
    weeks = [...data];
  })

  export let loginFinished;

  if(user == null && loginFinished) {
    navigate('/wear-testing/login')
  }
</script>




<div class="submit_container">
{#if user != null}

  <input
    id="fileid"
    on:change={(event) => onFileInputChange(event)}
    type="file"
    hidden
  />




  <h1 class="header_text" style="margin-top: 20px" >FIELD NOTES</h1>
  <p class="body_text">
      Upload pictures and videos of your wear testing journey here weekly for our research team to review. 
  </p>
  
  
  
  
  
  <WeekDropdown weeks={weeks} selectedWeek={currentWeek} onChangeSelectedWeek={(week) => {currentWeek = week }} />




  <div style="height: 25px" />
    {#if uploadCompleted}
      <p class="body_text">
        <b>Upload completed.</b> You may submit more than one file for each week.
      </p>
    {/if}

    {#if currentWeek != ""}
    <WideButton onClick={onClickUploadImage} isDisabled_BLACK={uploadSource != undefined} text={`UPLOAD A FILE`} />
    {/if}
    {#if imageOrVideoFile != undefined}
      {#if isFileMp4(imageOrVideoFile)}
        {#if uploadSource != undefined}
          <div style="height: 25px" />
          <!-- svelte-ignore a11y-media-has-caption -->
          <video style="width: 100%" src={uploadSource} controls="controls" />
          {#if fileIsUploading == false}
          <p on:click={cancelUpload} style="cursor: pointer; margin: 0; text-decoration: underline" class="body_text">REMOVE UPLOAD</p>
          {/if}
          <div style="height: 10px" />
          {#if fileIsUploading}
            <ProgressBar progress={progressCompleted} />
          {/if}
          <div style="height: 25px" />
        {/if}
      {/if}

      {#if isFileImage(imageOrVideoFile)}
        {#if uploadSource != undefined}
          <div style="height: 25px" />
          <img
            src={uploadSource}
            alt=""
            style="width: 100%; border: 1px solid white"
          />
          {#if fileIsUploading == false}
          <p on:click={cancelUpload} style="cursor: pointer; margin: 0; text-decoration: underline" class="body_text">REMOVE UPLOAD</p>
          {/if}
          <div style="height: 10px" />
          {#if fileIsUploading}
            <ProgressBar progress={progressCompleted} />
          {/if}
          <div style="height: 25px" />
        {/if}
      {/if}

      <WideButton onClick={onUploadFile} isDisabled_BLACK={fileIsUploading} text={`SUBMIT ${currentWeek.weekName}`} disabledText={`UPLOAD IN PROGRESS`} />

      {/if}
    <div style="height: 55px" />







    <h1 class="header_text lunch_header">THE BRIEFING ROOM</h1>
    <p class="body_text">
      {briefingRoomDescription}
    </p>


    <WideButton onClick={onClickLunchRoom} isDisabled_RED={lunchRoomLink == ""} disabledText={`NO BRIEFING ROOM IN SESSION`} text={`ENTER BRIEFING ROOM`} />
    <div style="height: 55px" />



    <MessageBoard user={user} />


  <div style="height: 100px" />


{/if}

  <Footer />
</div>

<style>


  .submit_container {
    width: 100%;
    max-width: 500px;
  }


</style>
